import { useState } from "react";
import { format } from "date-fns";
import { CalendarIcon, X } from "lucide-react";

export default function DatePickerField({ value, onChange, testId, placeholder = "Pick a date" }) {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(value + "T00:00:00") : undefined;
  const label = date ? format(date, "PPP") : placeholder;

  return (
    <div className="relative">
      <button
        type="button"
        data-testid={testId}
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-sm text-left text-slate-300 hover:bg-white/[0.08] transition-colors"
      >
        <CalendarIcon size={14} className="text-slate-400" />
        <span className={date ? "text-white" : "text-slate-500"}>{label}</span>
        {value && (
          <span
            role="button"
            tabIndex={0}
            onClick={(e) => { e.stopPropagation(); onChange(""); }}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onChange(""); } }}
            className="ml-auto text-slate-500 hover:text-red-400 cursor-pointer"
            aria-label="Clear date"
          >
            <X size={14} />
          </span>
        )}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-[70]" onClick={() => setOpen(false)} />
          <div className="absolute z-[71] mt-2 rounded-xl border border-white/10 bg-[#0b1220] p-3 shadow-2xl w-[280px]">
            <input
              type="date"
              autoFocus
              data-testid={`${testId}-input`}
              value={value || ""}
              onChange={(e) => {
                onChange(e.target.value);
                if (e.target.value) setOpen(false);
              }}
              className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 [color-scheme:dark]"
            />
            <div className="mt-3 grid grid-cols-3 gap-2">
              {[
                { label: "Today", days: 0 },
                { label: "+7 days", days: 7 },
                { label: "+30 days", days: 30 },
              ].map((q) => (
                <button
                  key={q.label}
                  type="button"
                  onClick={() => {
                    const d = new Date();
                    d.setDate(d.getDate() + q.days);
                    onChange(format(d, "yyyy-MM-dd"));
                    setOpen(false);
                  }}
                  className="text-xs text-slate-300 rounded-lg bg-white/5 border border-white/10 hover:bg-white/[0.1] px-2 py-1.5"
                >
                  {q.label}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
